/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConstStringRuleArgumentDto } from './ConstStringRuleArgumentDto';
import {
    ConstStringRuleArgumentDtoFromJSON,
    ConstStringRuleArgumentDtoFromJSONTyped,
    ConstStringRuleArgumentDtoToJSON,
} from './ConstStringRuleArgumentDto';

/**
 * 
 * @export
 * @interface FlagConditionDto
 */
export interface FlagConditionDto {
    /**
     * 
     * @type {ConstStringRuleArgumentDto}
     * @memberof FlagConditionDto
     */
    argument: ConstStringRuleArgumentDto;
}

/**
 * Check if a given object implements the FlagConditionDto interface.
 */
export function instanceOfFlagConditionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "argument" in value;

    return isInstance;
}

export function FlagConditionDtoFromJSON(json: any): FlagConditionDto {
    return FlagConditionDtoFromJSONTyped(json, false);
}

export function FlagConditionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagConditionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argument': ConstStringRuleArgumentDtoFromJSON(json['argument']),
    };
}

export function FlagConditionDtoToJSON(value?: FlagConditionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argument': ConstStringRuleArgumentDtoToJSON(value.argument),
    };
}

